import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const apiVersion = "1.1-rev2";

export const veeam = defineConnector({
  identifier: "veeam",
  name: "Veeam Backup & Replication",
  tagLine: "Backup and recovery",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}:9419/.*`
      : "https://[^/]*:9419/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}:9419/api/oauth2/token`,
        method: "POST",
        headers: [{ name: "x-api-version", value: apiVersion }],
        formBody: {
          grant_type: "password",
          username: app.secret.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: {
        kind: "header",
        scheme: "Bearer",
        extraHeaders: [{ name: "x-api-version", value: apiVersion }],
      },
    }),
  steps: [
    {
      title: "Enable the REST API",
      items: [
        {
          kind: "markdown",
          content:
            "The Veeam Backup & Replication REST API listens on port **9419** on your backup server. Make sure the RESTful API service is enabled and reachable. See the [Veeam REST API docs](https://helpcenter.veeam.com/docs/backup/vbr_rest/requesting_authorization.html).",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "hostname",
          label: "Backup server host",
          required: true,
          placeholder: "vbr.example.com",
          helperText:
            "Hostname or IP of your VBR server (port 9419 is assumed).",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}:9419/api/v1/serverInfo`,
  },
});
